import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import {
  convertStringToArray,
  extractDate,
  sanitizeString,
} from "../../../Utils/utils";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import Viewer from "react-viewer";
import ShowTable from "../../../components/ShowTable";
import { imageUrl } from "../../../constants/constants";

const LatestNewsDetailPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const { getText } = useLanguageTranslation();
  const { nid } = useParams();
  const {
    data: latestNewsData = [],
    error,
    isLoading,
  } = useGetProtectedApiDataQuery({ url: "latest_news", lang: languageType });

  const transformedData = useMemo(() => {
    return latestNewsData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    }));
  }, [latestNewsData]);

  const selectedNews = transformedData.find((news) => news.nid === nid);

  const selectedTitle = sanitizeString(selectedNews?.title);
  const selectedDescription = sanitizeString(selectedNews?.body);

  const lastUpdatedOn = useMemo(() => {
    return extractDate(selectedNews);
  }, [selectedNews]);

  const modifiedObj = {
    ...selectedNews,
    field_download: convertStringToArray(selectedNews?.field_download),
  };

  const file_ext = modifiedObj?.field_latest_news_video?.slice(-3);

  const handleImageClick = (image) => {
    setVisible(true);
    setCurrentImages([
      {
        src: imageUrl + image.field_upload_image[0].file_path,
        alt: selectedTitle,
      },
    ]);
    setActiveIndex(0);
  };

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Latest News", "नवीनतम समाचार")}
        titleLink="/latest-news-detail"
        titleTwo={selectedTitle}
        levelTwo={true}
        levelThree={false}
        isActive={selectedTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="title-sec">{/* <h4>{selectedNews.title}</h4> */}</div>

          <section className="news-detail">
            <div className="container">
              {selectedNews ? (
                <>
                  <div className="row mb-5">
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                      <div
                        className="card-sec"
                        onClick={() => handleImageClick(selectedNews)}
                      >
                        <div className="img-sec">
                          <img
                            src={
                              selectedNews.field_upload_image?.[0]?.file_path
                                ? imageUrl +
                                  selectedNews.field_upload_image[0].file_path
                                : "images/dummy.png"
                            }
                            alt={selectedTitle}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                      <div className="title-sec">
                        <h4>{selectedTitle}</h4>
                      </div>
                      <div className="about_inntxt">
                        <p>{selectedDescription}</p>
                      </div>

                      {/* video if present */}
                      {modifiedObj.field_latest_news_video &&
                      file_ext === "mp4" ? (
                        <>
                          <div className="title4">
                            <h4>Video</h4>
                          </div>
                          <video controls>
                            <source
                              src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-07/${selectedNews.field_latest_news_video}`}
                              type="audio/mpeg"
                            />
                          </video>
                        </>
                      ) : modifiedObj.field_latest_news_video &&
                        file_ext === "mp3" ? (
                        <>
                          <div className="title4">
                            <h4>Audio</h4>
                          </div>
                          <audio controls>
                            <source
                              src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-07/${selectedNews.field_latest_news_video}`}
                              type="audio/mpeg"
                            />
                          </audio>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    {/* table data if present */}
                    {selectedNews.field_download && (
                      <ShowTable data={modifiedObj.field_download} />
                    )}
                  </div>
                </>
              ) : (
                <p>News with id {nid} not found</p>
              )}
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            </div>
          </section>
          <Viewer
            visible={visible}
            onClose={() => setVisible(false)}
            onMaskClick={() => setVisible(false)}
            images={currentImages}
            activeIndex={activeIndex}
            rotatable={false}
            zoomable={true}
            scalable={false}
            drag={false}
            // downloadable={true}
          />
        </div>
      </div>
    </>
  );
};

export default LatestNewsDetailPage;
